import { apiRequest } from './client';
import type { EventOut, HomeBundle } from './types';

export async function getHome(): Promise<HomeBundle> {
  return apiRequest<HomeBundle>('/home');
}

export async function listEvents(opts?: { from?: string; to?: string }): Promise<EventOut[]> {
  return apiRequest<EventOut[]>('/events', {
    query: { from: opts?.from, to: opts?.to },
  });
}
